import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import apolloWrapper from '@hoc/apolloWrapper';
import { I18NProvider, getClientLocale } from '@utils/i18n';
import { CatalogTopBannerContainer } from '@containers/CatalogTopBanner';

const CatalogTopBannerWithApollo = apolloWrapper(CatalogTopBannerContainer);

// consts
const container = document.getElementById('js-catalog-top-banner');

if (container) {
  const root = createRoot(container);
  const { lang, routerBasename } = getClientLocale();

  root.render(
    (
      <BrowserRouter basename={routerBasename}>
        <I18NProvider lang={lang}>
          {
            () => <CatalogTopBannerWithApollo />
          }
        </I18NProvider>
      </BrowserRouter>
    ),
  );
}
